import React, { useEffect, useState } from "react";
import "./BlogCard.css";
import { createPortal } from "react-dom";
import { useAppContext } from "../../contexts/AppContext";
import axios from "axios";
import parse from "html-react-parser";
import { isImage, isVideo } from "../MediaFilter";

function BlogCard({ data }) {
  const { backendUrl, translate, getImageUrl } = useAppContext();
  const [seeMore, setSeeMore] = useState(false);
  const [company, setCompany] = useState(null);
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const companyRoute = "/company";

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await axios.get(`${backendUrl}${companyRoute}`);
        if (Array.isArray(response?.data) && response?.data?.length > 0) {
          setCompany(response.data[0]);
        }
      } catch (error) {
        console.error("Error fetching company data", error);
      }
    };
    fetchdata();
  }, [backendUrl]);

  const formattedDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const images = Array.isArray(data.images) ? data.images : [];
  const newsContent = data.News || "";
  const shouldTruncate = newsContent.length > 180 && !seeMore;

  return (
    <div className="compact-blog-card shadow-sm">
      {/* Fullscreen Image Overlay */}
      {fullscreenImage && createPortal(
        <div className="fullscreen-overlay" onClick={() => setFullscreenImage(null)}>
          <div className="fullscreen-content" onClick={(e) => e.stopPropagation()}>
            <img src={fullscreenImage} alt="Fullscreen" />
            <button className="close-btn" onClick={() => setFullscreenImage(null)}>
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
        </div>,
        document.body
      )}

      {/* Header */}
      <div className="compact-card-header">
        <div className="compact-profile-pic">
          {company?.images?.[0] && (
            <img
              src={getImageUrl(company.images[0])}
              alt="profile"
              className="compact-round-img"
            />
          )}
        </div>
        <div className="compact-header-info">
          <h6 className="compact-user-name">
            {company?.title ? parse(translate(company.title)) : "Dermatology Clinic"}
          </h6>
          <span className="compact-post-date">
            {formattedDate(data.createdAt)}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="compact-card-content">
        <div className="compact-text-body">
          {shouldTruncate ? (
            <>
              {parse(translate(newsContent).slice(0, 180))}
              <span
                className="compact-see-more"
                onClick={() => setSeeMore(true)}
              >
                ... {translate("read more")}
              </span>
            </>
          ) : (
            <>
              {parse(translate(newsContent))}
              {newsContent.length > 180 && (
                <span className="compact-see-more ms-2" onClick={() => setSeeMore(false)}>
                  {parse(translate("show less"))}
                </span>
              )}
            </>
          )}
        </div>

        {/* Media Layout */}
        {images.length > 0 && (
          <div className={`compact-media-grid grid-${Math.min(images.length, 3)}`}>
            {images.slice(0, 3).map((media, index) => (
              <div key={index} className="compact-media-item">
                {isImage(media) ? (
                  <img
                    src={getImageUrl(media)}
                    alt="post"
                    className="compact-post-media pointer"
                    onClick={() => setFullscreenImage(getImageUrl(media))}
                  />
                ) : isVideo(media) ? (
                  <video
                    src={getImageUrl(media)}
                    controls
                    className="compact-post-media"
                    preload="metadata"
                  />
                ) : null}
                {images.length > 3 && index === 2 && (
                  <div className="compact-media-overlay">
                    <span>+{images.length - 3}</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default BlogCard;
